import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ResumeLibrarySelector } from "@/components/ResumeLibrarySelector";
import { ResumeMatchTestLibrary } from "@/components/ResumeMatchTestLibrary";
import { ResumeLibraryEnhanced } from "@/components/ResumeLibraryEnhanced";
import { TailoredDocumentLibrary } from "@/components/TailoredDocumentLibrary";

interface ResumeLibraryProps {
  onUploadNew: () => void;
  onBack?: () => void;
  initialTab?: 'analyzed' | 'saved';
  autoSelectTailored?: boolean;
}

type LibraryType = 'match-tested' | 'saved' | 'tailored' | null;

export function ResumeLibrary({ onUploadNew, onBack, initialTab = 'analyzed', autoSelectTailored }: ResumeLibraryProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedLibrary, setSelectedLibrary] = useState<LibraryType>(null);

  // Auto-select tailored library if coming from tailored document detail OR if explicitly requested
  useEffect(() => {
    if (location.state?.autoSelectTailored || autoSelectTailored) {
      setSelectedLibrary('tailored');
    }
  }, [location.state, autoSelectTailored]);

  const handleBackToSelector = () => {
    setSelectedLibrary(null);
  };

  // If no library is selected, show the selector
  if (selectedLibrary === null) {
    return (
      <ResumeLibrarySelector 
        onBack={onBack}
        onSelectLibrary={setSelectedLibrary}
      />
    );
  }

  // Render the selected library
  switch (selectedLibrary) {
    case 'match-tested':
      return (
        <ResumeMatchTestLibrary 
          onBack={handleBackToSelector}
        />
      );
    
    case 'saved':
      return (
        <ResumeLibraryEnhanced 
          onBack={handleBackToSelector}
        />
      );
    
    case 'tailored':
      return (
        <TailoredDocumentLibrary 
          onBack={handleBackToSelector}
          onUploadNew={onUploadNew}
        />
      );
    
    default:
      return (
        <ResumeLibrarySelector 
          onBack={onBack}
          onSelectLibrary={setSelectedLibrary}
        />
      );
  }
}